import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, OverlayTrigger, Popover, Tooltip, Spinner } from 'react-bootstrap'
import EmailPhoneCombine from '../../jsx/components/fields/emailPhoneField'
import TextArea from '../../jsx/components/fields/textArea'
import PrimaryButton from '../../jsx/components/button/primaryButton'
import Avatar from '../../jsx/components/fields/avatar'
import profileAv from '../../icons/photos/profileAvatar.png';
import filter from '../../icons/photos/filter.svg';
import './userProfile.scss'
import InputField from '../../jsx/components/fields/inputField'
import SearchAddressInput from '../../jsx/components/fields/searchAddressInput'
import Bio from './bio'
import { element } from 'prop-types'
import PaymentInfo from './paymentInfo'
import { useDispatch, useSelector } from 'react-redux'
import WorkInfo from './workInfo'
import UploadDocuments from './uploadDocuments'
import Earnings from '../paymentModule/earnings'
import UserSubscriptions from './userSubscriptions'
import { setAccountDetailsModalTriggerRedux, setCurrentPage, setInprogressServiceCount, setUserProfileTab } from '../../feature/userData/userData'
import ReviewsRatings from './reviewsRatings'
import Subscription from '../subscription/subscription'
import { getCounterApi } from '../../service/api/ticket/serviceCounters'
import EarningsCopy from '../paymentModule/earnings copy'
import { FaInfoCircle } from 'react-icons/fa'

const UserProfile = () => {
    const { role, permissionArr, userName, roleDisplayName, profilePicture, isVerified, avgRatingFloat, companyId, userProfileTab, totalCreditsInCents, serviceRequestFlagPro, proOptionFlag } = useSelector((state) => state.user);
    const { totalEarned } = useSelector((state) => state.finance);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCurrentPage("Profile"))
    }, [])
    const permissionArray = permissionArr[0] || []
    // const [userProfileTab, setTabsToggle] = useState(1);
    const [editProfileTrigger, setEditProfileTrigger] = useState(false);

    // Horizontal Scroll for navbar functions 
    const [isScrolling, setIsScrolling] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    const navbarRef = useRef(null);

    const onMouseDown = (e) => {
        setIsScrolling(true);
        setStartX(e.pageX - navbarRef.current.offsetLeft);
        setScrollLeft(navbarRef.current.scrollLeft);
    };

    const onMouseLeave = () => {
        setIsScrolling(false);
    };

    const onMouseUp = () => {
        setIsScrolling(false);
    };

    const onMouseMove = (e) => {
        if (!isScrolling) return;
        e.preventDefault();
        const x = e.pageX - navbarRef.current.offsetLeft;
        const walk = (x - startX) * 2; // The multiplier 2 determines the scroll speed
        navbarRef.current.scrollLeft = scrollLeft - walk;
    };

    // Jobs counters functions
    const [counters, setCounters] = useState({});
    const [countersLoading, setCountersLoading] = useState(false);
    const handleGetCountersFn = () => {
        setCountersLoading(true);
        let details = {
            scheduled_tickets_flag: 2,
        };
        dispatch(
            getCounterApi(
                details,
                (res) => {
                    setCounters(res.data);
                    setCountersLoading(false);
                    // dispatch(setInprogressServiceCount(res?.data?.in_progress_services_count))
                },
                () => {
                    setCountersLoading(false);
                }
            )
        );
    }
    useEffect(() => {
        if (permissionArray.includes("UPDATE WORK INFORMATION")) {
            handleGetCountersFn();
        }
    }, []);

    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });


    useEffect(() => {
        return () => {
            dispatch(setUserProfileTab(1))
        }
    }, [])




    return (
        <>
            <div className='row mx-0 mx-3'>
                <div className='col-12'>
                    {/* Profile Header overview */}
                    <div className='row'>
                        <div className='col-12'>
                            <div className='row'>
                                <div className='col-sm-6 d-flex mt-2'>
                                    <div className='border mx-0 row w-100 me-sm-3'>

                                        <div className='col-4 align-items-center d-flex justify-content-center px-0'>
                                            <div
                                                className='d-flex align-items-center justify-content-center rounded-circle bg-light position-relative'
                                                style={{ width: '70px', height: '70px' }}
                                            >
                                                <img
                                                    src={profilePicture}
                                                    className='w-100 h-100 rounded-circle border cursor-pointer'
                                                    alt="profile"
                                                    onClick={() => {
                                                        dispatch(setUserProfileTab(1));
                                                        dispatch(setAccountDetailsModalTriggerRedux(true));
                                                        // setEditProfileTrigger(true);
                                                    }}
                                                />
                                                <img
                                                    className='edit-profile-icon cursor-pointer'
                                                    src={filter}
                                                    alt=""
                                                    style={{ top: "-6px", right: '-14px' }}
                                                    onClick={() => {
                                                        dispatch(setUserProfileTab(1));
                                                        dispatch(setAccountDetailsModalTriggerRedux(true));
                                                        // setEditProfileTrigger(true);
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className='col-8  py-4 px-2' >
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div className='fs-7 d-flex flex-column justify-content-center'>
                                                    {!permissionArray.includes("SCAN TAB") && !permissionArray.includes("VIEW REGISTERED COMPANIES LIST") && <div>
                                                        {isVerified == 1 && <span><i className="bi bi-patch-check-fill pe-2 text-success"></i></span>}
                                                        <span>
                                                            {permissionArray.includes("UPDATE WORK INFORMATION") && `${isVerified == 1 ? "Verified" : "Not Verified"}`}
                                                            {` ${roleDisplayName}`}
                                                        </span>
                                                    </div>}

                                                    <div className='fs-4 fw-bold text-black'>
                                                        <span>{userName}</span>
                                                    </div>

                                                    {permissionArray.includes("UPDATE WORK INFORMATION") &&
                                                        <div className='d-flex align-items-center'>
                                                            <div className="tooltipCustom me-2">
                                                                <span className="tooltiptextCustom w-100 d-flex align-items-start flex-column" style={{ minWidth: 'max-content' }}>
                                                                    <div>
                                                                        {`${proOptionFlag == 1 ? "Local Pro" :
                                                                            proOptionFlag == 2 ? "Remote Pro" :
                                                                                proOptionFlag == 3 ? "Estimator Pro" :
                                                                                    proOptionFlag == 4 ? "All-in-one Pro" : "Remote Pro"}`}
                                                                    </div>
                                                                    <div>{`Ability to accept 
                                                                    ${proOptionFlag == 1 ? "Local Services" :
                                                                            proOptionFlag == 2 ? "Remote Services" :
                                                                                proOptionFlag == 3 ? "Estimate Services" :
                                                                                    proOptionFlag == 4 ? "All Services" : "Service"}`}</div>
                                                                </span>
                                                                <span
                                                                    onClick={() => { }}
                                                                    className={`cursor-pointer text-hovered`}
                                                                >
                                                                    <FaInfoCircle style={{ fontSize: "12px" }} />
                                                                </span>
                                                            </div>

                                                            <div className='fs-5 fw-bold'>
                                                                <span>{`Pro type: `}</span>
                                                                <span>{`${proOptionFlag == 1 ? "Local Pro" :
                                                                    proOptionFlag == 2 ? "Remote Pro" :
                                                                        proOptionFlag == 3 ? "Estimator Pro" :
                                                                            proOptionFlag == 4 ? "All-in-one Pro" : "Remote Pro"}`}</span>
                                                            </div>
                                                        </div>
                                                    }



                                                    <div className='fs-6 mt-2'>
                                                        <span>{`Available credit balance: `}</span>
                                                        <span className='text-black font-w600'>{`${USDollar.format(totalCreditsInCents / 100)}`}</span>
                                                    </div>
                                                </div>

                                                <div className='fs-5 fw-bold'>
                                                    <span className='d-flex align-items-center'>
                                                        {avgRatingFloat?.toFixed(2)}
                                                        <i class="bi bi-star-fill ps-2"></i>
                                                    </span>
                                                </div>

                                            </div>

                                        </div>
                                        {/* <div className='col-2 d-flex flex-column justify-content-center p-4 px-0' >
                                            <div className='fs-5 fw-bold'>
                                                <span className='d-flex align-items-center'>
                                                    {avgRatingFloat?.toFixed(2)}
                                                    <i class="bi bi-star-fill ps-2"></i>
                                                </span>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>



                                {permissionArray.includes("UPDATE WORK INFORMATION") && <div className='col-sm-6 d-flex justify-content-around mt-2' >
                                    <div className='col-4 d-flex justify-content-center align-items-center bg-light me-1 text-center p-4' >
                                        <div className='align-items-center d-flex flex-column justify-content-center'>
                                            {countersLoading ?
                                                <div>
                                                    <Spinner animation="border" size="sm" />
                                                </div> :
                                                <>
                                                    <div className='fs-6 fw-bold text-black'>
                                                        {`${USDollar.format(totalEarned)}`}
                                                    </div>
                                                    <div className='fs-7'>
                                                        {"Earned"}
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </div>

                                    <div className='col-4 d-flex justify-content-center align-items-center bg-light me-1 text-center p-4' >
                                        <div className='align-items-center d-flex flex-column justify-content-center'>
                                            {countersLoading ?
                                                <div>
                                                    <Spinner animation="border" size="sm" />
                                                </div> :
                                                <>
                                                    <div className='fs-6 fw-bold text-black'>
                                                        {`${counters?.sent_service_requests_count || 0} video links`}
                                                    </div>
                                                    <div className='fs-7'>
                                                        {"Sent"}
                                                    </div>
                                                </>}
                                        </div>
                                    </div>

                                    <div className='col-4 d-flex justify-content-center align-items-center bg-light text-center p-4' >
                                        <div className='align-items-center d-flex flex-column justify-content-center'>
                                            {countersLoading ?
                                                <div>
                                                    <Spinner animation="border" size="sm" />
                                                </div> :
                                                <>
                                                    <div className='fs-6 fw-bold text-black'>
                                                        {`${counters?.closed_services_count || 0} jobs`}
                                                    </div>
                                                    <div className='fs-7'>
                                                        {"Done"}
                                                    </div>
                                                </>
                                            }

                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>

                    {permissionArray.includes("UPDATE WORK INFORMATION") &&
                        <div className='fs-6 mt-2'>
                            <span className='text-black font-w600'>{`Note: `}</span>
                            <span className=''>{`To change your pro type, click on Profile icon in header section and then click on "Update Pro type"`}</span>
                        </div>
                    }

                    {/* Navigations profile */}
                    <div
                        className='border-bottom mt-2 overflow-auto row text-nowrap user-profile-nav-bar whitespace-nowrap'
                        ref={navbarRef}
                        onMouseDown={onMouseDown}
                        onMouseLeave={onMouseLeave}
                        onMouseUp={onMouseUp}
                        onMouseMove={onMouseMove}
                    >
                        <div className='col-12 d-flex px-0 fs-5 font-w500'>
                            <div
                                onClick={() => {
                                    // setTabsToggle(1)
                                    dispatch(setUserProfileTab(1))
                                }}
                                className={`cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative`}
                                style={{}}
                            >
                                <span className={`${userProfileTab === 1 ? "text-black" : "text-grey"} ${userProfileTab === 1 && "fw-bold"}`} >{"Overview"}</span>
                                {userProfileTab === 1 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px" }}> </div>}
                            </div>

                            {permissionArray.includes("UPDATE WORK INFORMATION") &&
                                <div
                                    onClick={() => {
                                        // setTabsToggle(2)
                                        dispatch(setUserProfileTab(2))
                                    }}
                                    className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative'
                                    style={{}}
                                >
                                    <span className={`${userProfileTab === 2 ? "text-black" : "text-grey"} ${userProfileTab === 2 && "fw-bold"}`}>{"Reviews and Ratings"}</span>
                                    {userProfileTab === 2 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                                </div>
                            }

                            {((permissionArray.includes("UPDATE WORK INFORMATION") && !companyId) || (permissionArray.includes("UPDATE WORK INFORMATION") && companyId && totalEarned > 0) || (role == 4) || permissionArray.includes("SCAN TAB")) &&
                                <div
                                    onClick={() => {
                                        // setTabsToggle(3)
                                        dispatch(setUserProfileTab(3))
                                    }}
                                    className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative'
                                    style={{}}
                                >
                                    {/* Pro connection with own customers flow changes condition removed -> (serviceRequestFlagPro != 1)) */}
                                    {/* <span className={`${userProfileTab === 3 ? "text-black" : "text-grey"} ${userProfileTab === 3 && "fw-bold"}`}>{`Payments ${((permissionArray.includes("UPDATE WORK INFORMATION") || (role == 4)) && (serviceRequestFlagPro != 1)) ? "and Payouts" : ""} `}</span> */}
                                    <span className={`${userProfileTab === 3 ? "text-black" : "text-grey"} ${userProfileTab === 3 && "fw-bold"}`}>{`Payments ${((permissionArray.includes("UPDATE WORK INFORMATION") || (role == 4))) ? "and Payouts" : ""} `}</span>
                                    {userProfileTab === 3 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                                </div>
                            }

                            {/* {permissionArray.includes("UPDATE WORK INFORMATION") &&
                                <div
                                    onClick={() => setTabsToggle(4)}
                                    className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative'
                                    style={{}}
                                >
                                    <span className={`${userProfileTab === 4 ? "text-black" : "text-grey"} ${userProfileTab === 4 && "fw-bold"}`}>{"Earnings"}</span>
                                    {userProfileTab === 4 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                                </div>
                            } */}

                            {/* (serviceRequestFlagPro !== 1) check removed because Pros connecting their own customers will get subscription plan */}
                            {/* {((permissionArray.includes("UPDATE WORK INFORMATION") && !companyId) || (role == 4)) && (serviceRequestFlagPro !== 1) && (permissionArray.includes("SUBSCRIPTION ENABLE")) && */}
                            {((permissionArray.includes("UPDATE WORK INFORMATION") && !companyId) || (role == 4)) && (permissionArray.includes("SUBSCRIPTION ENABLE")) &&
                                <div
                                    onClick={() => {
                                        // setTabsToggle(5)
                                        dispatch(setUserProfileTab(5))
                                    }}
                                    className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative'
                                    style={{}}
                                >
                                    <span className={`${userProfileTab === 5 ? "text-black" : "text-grey"} ${userProfileTab === 5 && "fw-bold"}`}>{"Subscription"}</span>
                                    {userProfileTab === 5 && <div className='position-absolute w-100 bg-black' style={{ height: "3px", bottom: "0px" }}> </div>}
                                </div>
                            }

                            {/* <div onClick={() => setTabsToggle(6)} className='cursor-pointer align-items-cente d-flex justify-content-center px-4 py-3 position-relative' style={{}}>
                                <span className={`${userProfileTab === 6 ? "text-black" : "text-grey"} ${userProfileTab === 6 && "fw-bold"}`}>{"App settings"}</span>
                                {userProfileTab === 6 && <div className='position-absolute w-100 bg-black' style={{ height: "3px", bottom: "0px" }}> </div>}
                            </div> */}
                        </div>
                    </div>

                    {/* Overview */}
                    {userProfileTab === 1 &&
                        <div className='row my-3 ' style={{}}>
                            {/* (serviceRequestFlagPro !== 1) check removed because Pros connecting their own customers will get subscription plan */}
                            {/* <div className={`${(permissionArray.includes("UPDATE WORK INFORMATION") && (serviceRequestFlagPro !== 1)) ? "col-lg-4" : "col-lg-12"} pe-md-1 mt-2  d-flex`}> */}
                            <div className={`${(permissionArray.includes("UPDATE WORK INFORMATION")) ? "col-lg-4" : "col-lg-12"} pe-md-1 mt-2  d-flex`}>
                                {/* Account details */}
                                <Bio
                                // editProfileTrigger={editProfileTrigger}
                                // setEditProfileTrigger={setEditProfileTrigger}
                                />

                            </div>

                            {/* (serviceRequestFlagPro !== 1) check removed because Pros connecting their own customers will get subscription plan */}
                            {/* {(permissionArray.includes("UPDATE WORK INFORMATION") && (serviceRequestFlagPro !== 1)) && */}
                            {(permissionArray.includes("UPDATE WORK INFORMATION")) &&
                                <div className='col-lg-4 px-md-1  mt-2 d-flex'>
                                    {/* Expertise */}
                                    <WorkInfo />
                                </div>
                            }

                            {/* (serviceRequestFlagPro !== 1) check removed because Pros connecting their own customers will get subscription plan */}
                            {/* {(permissionArray.includes("UPDATE WORK INFORMATION") && (serviceRequestFlagPro !== 1)) && */}
                            {(permissionArray.includes("UPDATE WORK INFORMATION")) &&
                                <div className='col-lg-4 ps-md-1  mt-2    d-flex'>
                                    {/* <Documents /> */}
                                    <UploadDocuments />
                                </div>
                            }
                        </div>
                    }

                    {/* Reviews and Ratings */}
                    {userProfileTab === 2 &&
                        <div className='row my-1 '>
                            <div className='col-lg-12 mt-1  d-flex'>
                                <ReviewsRatings />

                            </div>
                        </div>
                    }

                    {/* Payments and Payouts */}
                    {userProfileTab === 3 &&
                        <div className='row my-3 '>
                            <div className='col-lg-12 mt-2  d-flex'>
                                <PaymentInfo />

                            </div>
                        </div>
                    }

                    {/* Earnings */}
                    {userProfileTab === 4 &&
                        <div className='row my-3 '>
                            <div className='col-lg-12 mt-2  d-flex'>
                                <Earnings />
                            </div>
                        </div>
                    }

                    {/* Subscription */}
                    {userProfileTab === 5 &&
                        <div className='row my-3  '>
                            <div className='col-lg-12 mt-2'>


                                <Subscription />

                            </div>
                        </div>
                    }

                    {/* Earnings 2 */}
                    {userProfileTab === 6 &&
                        <div className='row my-3 '>
                            <div className='col-lg-12 mt-2  d-flex'>
                                <EarningsCopy />
                            </div>
                        </div>
                    }



                </div>
            </div>




        </>
    )
}

export default UserProfile